(function () {
	document.addEventListener('shopify:section:load', function () {
		const slider = new Swiper('.js-media-list', getSliderSettings);

		const subSlider = new Swiper('.js-media-sublist', getSubSliderProductSettings);

		setTimeout(function () {
			slider.update();
			subSlider.update();
		}, 100)
	});
})();

/* ------------------------------------------------------------------
   Sticky mobile add-to-cart — added 17 Sept 2026.

   The artwork stays first on mobile. This pins a compact bar to the
   bottom of the screen carrying the thumbnail, the live price and an
   Add to cart button, shown only while the real button is off screen.

   It never duplicates the product form: taps are forwarded to the
   real submit button, so variant selection, validation, the cart
   drawer and analytics behave exactly as they already do.
   ------------------------------------------------------------------ */
(function () {
	var MOBILE = '(max-width: 749px)';

	function init() {
		if (!window.matchMedia(MOBILE).matches) return;

		var realButton = document.querySelector('[id^="ProductSubmitButton-"]');
		var priceBlock = document.querySelector('[id^="price-"]');
		if (!realButton || !priceBlock) return;
		if (document.getElementById('StickyAtc')) return;

		var style = document.createElement('style');
		style.textContent = [
			'#StickyAtc{position:fixed;left:0;right:0;bottom:0;z-index:2147483000;display:block;',
			'background:rgb(var(--color-background));border-top:1px solid rgba(var(--color-foreground),0.14);',
			'box-shadow:0 -0.2rem 1.6rem rgba(var(--color-foreground),0.08);padding:0.9rem 1.4rem;',
			'padding-bottom:calc(0.9rem + env(safe-area-inset-bottom, 0px));}',
			'#StickyAtc[hidden]{display:none;}',
			'#StickyAtc .sticky-atc__inner{display:flex;align-items:center;gap:1.2rem;}',
			'#StickyAtc .sticky-atc__thumb{flex:0 0 auto;width:4.4rem;height:4.4rem;}',
			'#StickyAtc .sticky-atc__thumb img{width:100%;height:100%;object-fit:contain;display:block;}',
			'#StickyAtc .sticky-atc__text{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;line-height:1.25;}',
			'#StickyAtc .sticky-atc__name{font-size:1.1rem;letter-spacing:0.08em;text-transform:uppercase;',
			'color:rgba(var(--color-foreground),0.6);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
			'#StickyAtc .sticky-atc__price{font-size:1.6rem;color:rgb(var(--color-foreground));white-space:nowrap;}',
			'#StickyAtc .sticky-atc__button{flex:0 0 auto;min-height:4.6rem;padding:0 2.2rem;border:0;cursor:pointer;',
			'background:rgb(var(--color-button));color:rgb(var(--color-background));font-size:1.3rem;',
			'letter-spacing:0.12em;text-transform:uppercase;}',
			'#StickyAtc .sticky-atc__button[disabled]{opacity:0.45;cursor:default;}',
			'@media (max-width:749px){body{padding-bottom:7rem;}',
			'.product__title__wrapper .product__title{font-size:2.2rem;line-height:1.15;}',
			/* Float the scroll-top button and the Google reviews badge clear of the bar. */
			'.scroll-top__block{bottom:9rem !important;}',
			'#google-merchantwidget-iframe-wrapper{bottom:9rem !important;}}'
		].join('');
		document.head.appendChild(style);

		var heading = document.querySelector('h1.product__title');
		var name = heading ? heading.textContent.split('·')[0].trim() : '';
		var img = document.querySelector('.product__media img');

		var bar = document.createElement('div');
		bar.id = 'StickyAtc';
		bar.hidden = true;
		bar.innerHTML =
			'<div class="sticky-atc__inner">' +
			'<div class="sticky-atc__thumb" hidden><img alt="" width="44" height="44"></div>' +
			'<div class="sticky-atc__text"><span class="sticky-atc__name"></span><span class="sticky-atc__price"></span></div>' +
			'<button type="button" class="sticky-atc__button">Add to cart</button>' +
			'</div>';
		document.body.appendChild(bar);

		bar.querySelector('.sticky-atc__name').textContent = name;

		// The gallery image is lazy-loaded, so its resolved URL may not exist yet.
		var thumb = bar.querySelector('.sticky-atc__thumb');
		var thumbImg = thumb.querySelector('img');

		function syncThumb() {
			var src = img && (img.currentSrc || img.src);
			if (!src) return;
			thumbImg.src = src;
			thumb.hidden = false;
		}

		syncThumb();
		if (img && !img.complete) img.addEventListener('load', syncThumb);

		var out = bar.querySelector('.sticky-atc__price');
		var button = bar.querySelector('.sticky-atc__button');

		function syncPrice() {
			var el =
				priceBlock.querySelector('.price-item--sale') ||
				priceBlock.querySelector('.price-item--regular') ||
				priceBlock.querySelector('.price-item');
			if (!el) return;
			var text = el.textContent.replace(/\s+/g, ' ').trim();
			if (text) out.textContent = text;
		}

		function syncState() {
			button.disabled = realButton.disabled;
		}

		syncPrice();
		syncState();

		new MutationObserver(function () {
			syncPrice();
			syncState();
			updateVisibility();
		}).observe(priceBlock, { childList: true, subtree: true, characterData: true });

		new MutationObserver(syncState).observe(realButton, {
			attributes: true,
			attributeFilter: ['disabled']
		});

		button.addEventListener('click', function () {
			realButton.click();
		});

		function updateVisibility() {
			var r = realButton.getBoundingClientRect();
			var onScreen = r.top < window.innerHeight && r.bottom > 0;
			bar.hidden = onScreen;
		}

		updateVisibility();
		window.addEventListener('scroll', updateVisibility, { passive: true });
		window.addEventListener('resize', updateVisibility);
		window.addEventListener('load', updateVisibility);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
